var exports = {
  "kL": "AudioPlayer.module__container___WUNlQ2",
  "Md": "AudioPlayer.module__fileName___WUNlQ2",
  "NE": "AudioPlayer.module__progressSection___WUNlQ2",
  "hr": "AudioPlayer.module__progressBar___WUNlQ2",
  "Ey": "AudioPlayer.module__timeDisplay___WUNlQ2",
  "ne": "AudioPlayer.module__controls___WUNlQ2",
  "gm": "AudioPlayer.module__mainControls___WUNlQ2",
  "Rr": "AudioPlayer.module__playButton___WUNlQ2",
  "$3": "AudioPlayer.module__seekButton___WUNlQ2",
  "f6": "AudioPlayer.module__secondaryControls___WUNlQ2",
  "Wq": "AudioPlayer.module__volumeControl___WUNlQ2",
  "Sn": "AudioPlayer.module__playbackRate___WUNlQ2",
  "Hw": "AudioPlayer.module__mobile___WUNlQ2",
};

module.exports = exports;
